<div class="card-info-section" (click)="onCardSelect()">
  <div class="card-info-container g-0">
    <div class="left-col">
      <img [src]="cardDetails.url" [alt]="cardDetails.altText" class="card-icon" />
    </div>
    <div class="middle-col">
      <div>{{ paymentInfo?.maskedAccountNumber }}</div>
      <div>{{ paymentInfo?.firstName }} {{ paymentInfo?.lastName }}{{ address }}</div>
    </div>

    @if (paymentInfo?.isSelected) {
      <div class="right-col">
        {{ expiryDateFormat }}
      </div>
    }

    @if (paymentInfo?.isSelected) {
      <div class="right-col">
        <img class="selected-card" src="../../../../../../assets/icons/Done.svg" alt="Done" />
      </div>
    }
  </div>
</div>
